var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { windowAvailable } from '../utils/client-detection';
import { i18nKeys } from './i18nKeys';
import useTranslations from '../store/translations';
import { cleanTranslations } from '../utils/cleanTranslations';
export const i18nScope = ['compareLayer', 'ngc'];
export const useI18n = () => {
    const textKeyMode = windowAvailable()
        ? new URLSearchParams(window.location.search).get('d_text') === 'true'
        : undefined;
    const translations = useTranslations((state) => state.translations);
    const keyExists = (key) => {
        return !!Object.keys(i18nKeys).find((i18nKey) => (key === null || key === void 0 ? void 0 : key.trim()) === (i18nKey === null || i18nKey === void 0 ? void 0 : i18nKey.trim()));
    };
    const i18n = (key, placeholder) => {
        var _a, _b;
        if (!keyExists(key)) {
            return `missing translation for key: ${key}`;
        }
        const defaultMessage = i18nKeys[key];
        const translation = (_a = cleanTranslations(translations)) === null || _a === void 0 ? void 0 : _a[key];
        if (textKeyMode) {
            return `[${key}]${translation !== null && translation !== void 0 ? translation : '-'}[END]`;
        }
        if (placeholder) {
            const reducedMessage = [...Object.entries(placeholder)].reduce((replacedMessage, [currentPlaceholder, currentValue]) => replacedMessage === null || replacedMessage === void 0 ? void 0 : replacedMessage.replace(`{{${currentPlaceholder}}}`, `${currentValue}`), translation !== null && translation !== void 0 ? translation : defaultMessage);
            return reducedMessage !== null && reducedMessage !== void 0 ? reducedMessage : `missing translation: ${key}`;
        }
        return (_b = translation !== null && translation !== void 0 ? translation : defaultMessage) !== null && _b !== void 0 ? _b : `missing translation: ${key}`;
    };
    return {
        i18n,
        i18nKeys,
    };
};
export const cherryPickTranslations = (messages, language) => {
    if (!language)
        return {};
    const normalizedLanguage = language === null || language === void 0 ? void 0 : language.toLowerCase();
    if (!(messages === null || messages === void 0 ? void 0 : messages[normalizedLanguage])) {
        console.error(`No translations found for language: ${language}, fetching`);
        return {};
    }
    return Object.entries(messages[normalizedLanguage]).reduce((acc, [key, value]) => {
        if (i18nScope.some((scope) => key.includes(scope))) {
            acc[key] = value;
        }
        return acc;
    }, {});
};
export function fetchTranslations(language, i18nService) {
    return __awaiter(this, void 0, void 0, function* () {
        return new Promise((resolve, reject) => {
            try {
                i18nService.setScopes(i18nScope);
                i18nService.registerCallback((messages) => {
                    const res = cherryPickTranslations(messages, language);
                    resolve(res);
                });
            }
            catch (err) {
                reject(err);
            }
        });
    });
}
